module.exports = __webpack_public_path__ + "img/CAD.005dc632.png";